import template from './flight-preferred-airline.html';

const DIRECTIVE_NAME = FlightPreferredAirline.DIRECTIVE_NAME = 'ktFlightPreferredAirline';
export default function FlightPreferredAirline() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightPreferredAirlineController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            errors: `=${DIRECTIVE_NAME}Errors`,
            isFormSubmitted: `=${DIRECTIVE_NAME}Submitted`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightPreferredAirlineController(
    $rootScope,
    staticDataGetter,
    l10nService
) {
    'ngInject';

    const vm = this;
    const SUGGESTIONS_COUNT = 7;

    Object.assign(vm, {
        $onInit,
        getAirlines,
        formatLabel,
    });

    function $onInit() {
        vm.placeholder = l10nService.localize('Start type to search');
    }

    function getAirlines(query) {
        return $rootScope.readOnlyMode
            ? []
            : staticDataGetter.getAirlines(query)
                .then((airlines) => airlines.slice(0, SUGGESTIONS_COUNT));
    }

    function formatLabel(model) {
        return angular.isObject(model) ? model.Name : model;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/flight-preferred-airline/flight-preferred-airline-component.js